<form [formGroup]="form" class="flex flex-column gap-3" (ngSubmit)="save()">

  <div class="flex flex-column gap-1">
    <label for="sourceBucket">Monitored bucket</label>
    <p-dropdown inputId="sourceBucket" formControlName="sourceBucket"
                [options]="projects" optionLabel="name" optionValue="project.bucket"
                styleClass="w-full"></p-dropdown>
  </div>

  <div class="flex flex-column gap-1">
    <label for="sourcePathPrefix">Monitored folder path</label>
    <input id="sourcePathPrefix" type="text" pInputText class="p-inputtext-sm w-full"
           formControlName="sourcePathPrefix" placeholder="bucket root"/>
    <span class="text-color-secondary text-sm">
      Files landing in this folder will trigger the Rule.
    </span>
  </div>

  <div class="flex flex-column gap-1">
    <label for="outputBucket">Output bucket</label>
    <p-dropdown inputId="outputBucket" formControlName="outputBucket"
                [options]="projects" optionLabel="name" optionValue="project.bucket"
                [showClear]="true" placeholder="Same as source bucket"
                styleClass="w-full"></p-dropdown>
  </div>

  <div class="flex flex-column gap-1">
    <label for="outputPathPrefix">Output path prefix (optional)</label>
    <input id="outputPathPrefix" type="text" pInputText class="p-inputtext-sm w-full"
           formControlName="outputPathPrefix" placeholder="e.g. results/"/>
  </div>

  <div class="flex flex-column gap-1">
    <label for="folderNamePattern">Output folder name pattern</label>
    <input id="folderNamePattern" type="text" pInputText class="p-inputtext-sm w-full"
           formControlName="folderNamePattern" placeholder="e.g. {{ '{' }}yyyy-MM-dd{{ '}' }}"/>
    <span class="text-color-secondary text-sm">
      {{ '{' }}yyyy-MM-dd{{ '}' }}-style date tokens are substituted at run time.
    </span>
  </div>

  <p-accordion>
    <p-accordionTab header="Advanced">
      <div class="flex flex-column gap-3">

        <div class="flex flex-column gap-1">
          <label for="filenameRegex">Filename regex (optional)</label>
          <input id="filenameRegex" type="text" pInputText
                 class="p-inputtext-sm w-full"
                 formControlName="filenameRegex"
                 [style.border-color]="!filenameRegexValid ? '#e24c4c' : null"
                 placeholder="e.g. .*\.ndpi"/>
          <span *ngIf="!filenameRegexValid" class="text-sm" style="color: red">
            Invalid regular expression.
          </span>
          <span *ngIf="filenameRegexValid" class="text-color-secondary text-sm">
            Matched against the full filename (case-insensitive). Leave blank to match every supported image.
          </span>
        </div>

        <div class="flex align-items-center gap-2">
          <p-checkbox formControlName="recursive" [binary]="true" inputId="recursive"></p-checkbox>
          <label for="recursive">Watch subfolders recursively</label>
        </div>

        <div class="flex flex-column gap-1">
          <label for="pollIntervalSeconds">Poll interval (seconds)</label>
          <p-inputNumber inputId="pollIntervalSeconds" formControlName="pollIntervalSeconds"
                         [min]="minPollIntervalSeconds" [showButtons]="true"></p-inputNumber>
          <span *ngIf="form.get('pollIntervalSeconds')?.invalid" class="text-sm" style="color: red">
            Minimum poll interval is {{minPollIntervalSeconds}} seconds.
          </span>
        </div>

        <div class="flex flex-column gap-1">
          <label>Regions</label>
          <span class="text-color-secondary text-sm" *ngIf="regionCount === 0">
            No regions drawn - every newly discovered file will run without a fixed region.
          </span>
          <span class="text-color-secondary text-sm" *ngIf="regionCount > 0">
            {{regionCount}} region(s) currently drawn will be applied to every newly discovered file.
          </span>
        </div>

      </div>
    </p-accordionTab>
  </p-accordion>

  <div class="flex justify-content-end gap-2">
    <button pButton type="button" label="Cancel" class="p-button-text" (click)="cancel()"></button>
    <button pButton type="submit" [label]="isEdit ? 'Save' : 'Create'"
            [loading]="submitting"
            [disabled]="submitting || form.invalid || !filenameRegexValid"></button>
  </div>
</form>
